<!-- 系统角色管理 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="titleRole">
      <div class="fuzzy-matching-top">
        <el-button type="primary" size="medium" class="query-button" @click="addRoleClick">新增授权用户</el-button>
        <el-button type="primary" size="medium" class="query-button" @click="BackClick">返回</el-button>
      </div>
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
          <el-table :header-cell-style="{ background: '#F2F2F2', color: '#000', }" ref="multipleTable" :data="tableData"
            tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column prop="username" label="名称">
            </el-table-column>
            <el-table-column prop="email" label="邮箱">
            </el-table-column>
            <el-table-column prop="mobile" label="手机">
            </el-table-column>
            <el-table-column label='操作'>
              <template #default="scope">
                <el-button size="medium" type="text" @click="deleteClick(scope.row)" class="shanchu">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block-fenye">
            <el-pagination :small="small" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
              :total="2" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </el-row>
      </div>
    </div>
    <AddEmpower v-if="AddShowEmpower" @addfanhui="addfanhui" :grandpaItem="grandpaItem"></AddEmpower>
  </div>
</template>
  
<script>
import { menuprivilegesUsers, removePrincipalDelet } from '@/assets/api/user.js'
import AddEmpower from './add-empower.vue'
import { fa } from 'element-plus/es/locale';
export default {
  props: ['userObj'],
  components: {
    AddEmpower
  },
  data() {
    return {
      Dform: {
        username: ''
      },
      tableData: [
        {
          username: 123,
        }
      ],
      pageInfo: {
        page: '1',
        pageSize: "10"
      },
      total: '',
      AddShowEmpower: false,
      grandpaItem: {}

    };
  },
  created() {
    this.getUserListVal()
  },
  mounted() {

  },
  methods: {
    addRoleClick() {
      // console.log('');
      this.grandpaItem = this.userObj
      this.AddShowEmpower = true
    },
    addfanhui() {
      // console.log('');
      this.AddShowEmpower = false
      this.getUserListVal()
    },
    //删除
    deleteClick() {
      const params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      removePrincipalDelet(params).then((res) => {
        // console.log(res,'1');
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.getUserListVal()
      }).catch((err) => {
        // console.log(err,'2');
        this.$message({
          type: 'error',
          message: err.response.data.msg
        });

      })
    },
    //返回
    BackClick() {
      this.$emit('fatchback')
    },
    // 列表
    getUserListVal() {
      const params = {
        roleId: this.userObj.id
      }
      menuprivilegesUsers(params).then((res) => {
        console.log(res.data.data, '11');
        this.tableData = res.data.data

      }).catch((err) => {
        console.log(err, '1');
      })
    }
  }
};
</script>
  
<style scoped lang="scss">
.fuzzy-matching-box {
  padding-top: 20px;
  width: 100%;
  height: 92%;
  background-color: #fff;
  border-radius: 8px;

  .titleRole {
    height: 100%;
  }

  .title-top {
    padding: 20px 20px;
  }

  .query-button {
    margin-left: 20px;
    // background-color: #1BC896;
  }

}

.fuzzy-matching-bottom {
  height: calc(100% - 170px);
  overflow: auto;
  position: relative;
  padding: 0px 20px;
  padding-top: 10px;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 8px;

  .top-first-line {
    height: 45px;
    line-height: 45px;

    /deep/ .tip-button {
      padding: 14px 14px;
      margin: 0px 3px;
    }

    .import-export-button {
      position: absolute;
      right: 20px;

      /deep/ .el-button--small {
        padding: 16px 24px;
        border: 1px solid #569CFF;
        color: #569CFF;
      }
    }
  }

  .list {
    position: relative;
    // margin-top: 10px;
    padding-bottom: 50px;

    .fenye {
      // float: right;
      text-align: center;
    }

    /deep/ {
      .el-table--small .cell {
        text-align: center;
      }

      .el-table td.el-table__cell,
      .el-table th.el-table__cell.is-leaf {
        border: 0px;
      }

      .el-table tr {
        height: 40px;
        cursor: pointer;
        font-size: 16px;
        color: black;
      }
    }

    .block-fenye {
      // float: right;
      position: absolute;
      bottom: 0px;
      left: 50%;
      transform: translate(-50%, 0);

    }
  }
}
</style>
  